import { Autocomplete, TextField } from "@mui/material";
import React, {useState, useEffect} from "react";
import { handleValidateCodevalue } from "../Utility/constant";
import { useSelector } from "react-redux";


export const AutoCompleteComponent = ({disabled,isLookup = false, isOwner=false,placeholder , isViewMode = false , optionSet, name, sx, value, onChange, label , error , required}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    
    return (
        <React.Fragment>
            <Autocomplete
                disabled = {isViewMode || disabled}
                options={optionSet}
                sx={sx}
                getOptionLabel={(option) => isOwner ? `${option?.firstName} ${option?.lastName}` : isLookup ? handleValidateCodevalue(internationalise,option?.name) : option?.name}
                value={value}
                filterSelectedOptions = {true}
                // filterSelectedOptions = {true}
                name = {name}
                onChange = {onChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        error={error}
                        sx={{padding: "0px !important"}}
                        required={required}
                        placeholder = {placeholder}
                        variant="standard"
                        // error={value ? false : requiredValue?.[name]}
                        label={label}
                        // sx={{width: true ? '50ch !important' : "65ch !important" , padding: "7px" }}
                        // placeholder="Select Company"
                        // InputLabelProps={{
                        //     shrink: true,
                        // }}
                    />
                )}
            />
        </React.Fragment>
    )
}

export default AutoCompleteComponent;